import { parseCloudflareSource, parseCloudflareSource as parseCloudflareSource$1, parseCloudflareVideoId } from "@videojs/media";
import { serializeEmbedParams } from "@videojs/media/dom";
//#region src/source.ts
/**
* Build the iframe `src` URL for an initial Cloudflare Stream embed from the given props.
*
* @internal
*/
function buildCloudflareIframeSrc(src, props = {}) {
	const parsed = parseCloudflareSource(src);
	if (!parsed) return "";
	const { referrerPolicy: _referrerPolicy, ...cloudflare } = props.source?.engine?.cloudflare ?? {};
	const params = {
		controls: props.controls === true ? null : 0,
		autoplay: props.autoplay || null,
		loop: props.loop || null,
		muted: props.defaultMuted || null,
		preload: props.preload || "metadata",
		poster: props.poster || null,
		...cloudflare
	};
	return `${parsed.origin ? `${parsed.origin}/${parsed.id}/iframe` : `${EMBED_BASE}/${parsed.id}`}?${serializeEmbedParams(params)}`;
}
const EMBED_BASE = "https://iframe.videodelivery.net";
//#endregion
export { buildCloudflareIframeSrc, parseCloudflareSource$1 as parseCloudflareSource, parseCloudflareVideoId };
